(function($){ 
  // THESE ARE INITIALISATIONS AND OPTIONS FOR THE PRODUCT TEMPLATE GALLERY ONLY
  theme.Product();

  $('.slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var zoomUrl = $('.slick-current').attr('src');
    console.log(zoomUrl);
    sliderZoom(zoomUrl);
  });

  /* SLICK SLIDER SWITH BASED ON VARIANTS */
  $('.product-single__thumbnails .product-single__photos--thumbnail').each(function(index){
    var thisID = $(this).data('id');

    slickIndex.push(thisID);
  });
  
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: false,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    autoplay: false
    ,vertical: true,
    verticalSwiping: true
  });

  function sliderZoom(el){
    var zoomUrl = el;
    $('.product-single__photos').zoom({ 
      url: zoomUrl,
      magnify: 1
    });

  }

  sliderZoom($('.slick-active img, .product-featured-img').attr('src'));

  // THIS IS A HELPER FOR OPTIONS SELECTION
  $('.single-option-selector').each(function(){
    $(this).on('change', function(e){
      // This will trigger every time someone changes a select box
      // Selected variant is set to data-variant, this is controlled in theme.js.liquid
      // Helpers
      var selectorID    = $(this).prop('id')
      ,   selectorClass = $(this).prop('class')
      ,   selectorData  = $(this).data('index')
      ,   selectorVal   = $(this).val();

    });
  });
})(jQuery);